import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { CurrentUserResponse } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);

  getCurrentUser(): Observable<CurrentUserResponse> {
    const url = buildUrl(environment.apiBaseUrl, environment.auth.currentUserPath);
    return this.http.get<CurrentUserResponse>(url);
  }
}

export class ClientUserError extends Error {
  constructor() {
    super('Access denied. This app is only available to client users.');
    this.name = 'ClientUserError';
  }
}

const buildUrl = (base: string, path: string): string => {
  if (!base) {
    return path;
  }

  const baseTrimmed = base.replace(/\/+$/, '');
  const pathTrimmed = path.replace(/^\/+/, '');
  return `${baseTrimmed}/${pathTrimmed}`;
};
